import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
    name: 'filter'
})
export class FilterPipe implements PipeTransform {
    transform(values: any[], predicate: any, args?: any): any[] {
        if (Array.isArray(values)) {
            return _.filter(values, args && _.isFunction(predicate) ? predicate(args) : predicate);
        }
        return values;
    }
}
